import { ChatMessage } from '../services/chatService';

// Right panel tab types
export type RightPanelTab = 'ai-overview' | 'requirements' | 'tasks' | 'architecture' | 'design' | 'user-flow' | 'preview' | 'env' | 'code' | 'cluster' | 'team' | 'organization' | 'payments';

// Mobile view toggle
export type MobileView = 'chat' | 'panel';

/* Tabs restricted on iOS per Apple App Store guideline 2.5.2. */
export const IOS_RESTRICTED_TABS = new Set<RightPanelTab>(['code', 'env', 'preview', 'cluster', 'payments']);

export const RIGHT_PANEL_TABS: { key: RightPanelTab; label: string; icon?: string }[] = [
  { key: 'ai-overview', label: 'AI Overview', icon: 'fa-solid fa-brain' },
  { key: 'tasks', label: 'Tasks', icon: 'fa-solid fa-tasks' },
  { key: 'requirements', label: 'System requirements', icon: 'fa-solid fa-clipboard-list' },
  { key: 'user-flow', label: 'User Flow', icon: 'fa-solid fa-user' },
  { key: 'design', label: 'Design', icon: 'fa-solid fa-palette' },
  { key: 'code', label: 'Code', icon: 'fa-solid fa-code' },
  { key: 'architecture', label: 'Architecture', icon: 'fa-solid fa-sitemap' },
  { key: 'env', label: 'Config', icon: 'fa-solid fa-key' },
  { key: 'payments', label: 'Payments', icon: 'fa-solid fa-credit-card' },
  { key: 'preview', label: 'Preview', icon: 'fa-solid fa-desktop' },
  { key: 'cluster', label: 'Cluster K8s', icon: 'fa-solid fa-dharmachakra' },
  { key: 'team', label: 'Team', icon: 'fa-solid fa-users' },
  { key: 'organization', label: 'Organization', icon: 'fa-solid fa-building' },
];

export const VALID_TAB_KEYS = new Set<RightPanelTab>(
  RIGHT_PANEL_TABS.map((t) => t.key)
);



const updateAtIndex = (messages: ChatMessage[], newMsg: ChatMessage, index: number): ChatMessage[] => {
  const updated = [...messages];

  updated[index] = newMsg;

  return updated;
};

export const upsertMessageInList = (
  messages: ChatMessage[],
  newMsg: ChatMessage
): ChatMessage[] => {
  const index = messages.findIndex((m) => m.id === newMsg.id);

  return index >= 0 ? updateAtIndex(messages, newMsg, index) : [...messages, newMsg];
};
